// 1234567.89 -> 1.234.567,9
export const formatNumberToMillionsClp = (inputNumber: number | string, decimals: number) => {
  const numberToFormat = Number(inputNumber);
  const formattedNumber = numberToFormat.toLocaleString('de', { //We have to set this as 'de', 'es' formatting only applies to numbers above 9999
    maximumFractionDigits: decimals,
  });
  return formattedNumber;
};
